import {
    getRoomDepositWaiting as apiGetRoomDepositWaiting,
    getRoomDepositSubtotal as apiGetRoomDepositSubtotal,
    updateRoomDeposit as apiUpdateRoomDeposit
} from '../../api/roomDeposit';

// Action Types
export const FETCH_ROOM_DEPOSIT_WAITING_REQUEST = 'FETCH_ROOM_DEPOSIT_WAITING_REQUEST';
export const FETCH_ROOM_DEPOSIT_WAITING_SUCCESS = 'FETCH_ROOM_DEPOSIT_WAITING_SUCCESS';
export const FETCH_ROOM_DEPOSIT_WAITING_FAILURE = 'FETCH_ROOM_DEPOSIT_WAITING_FAILURE';

export const FETCH_ROOM_DEPOSIT_SUBTOTAL_REQUEST = 'FETCH_ROOM_DEPOSIT_SUBTOTAL_REQUEST';
export const FETCH_ROOM_DEPOSIT_SUBTOTAL_SUCCESS = 'FETCH_ROOM_DEPOSIT_SUBTOTAL_SUCCESS';
export const FETCH_ROOM_DEPOSIT_SUBTOTAL_FAILURE = 'FETCH_ROOM_DEPOSIT_SUBTOTAL_FAILURE';

export const UPDATE_ROOM_DEPOSIT_REQUEST = 'UPDATE_ROOM_DEPOSIT_REQUEST';
export const UPDATE_ROOM_DEPOSIT_SUCCESS = 'UPDATE_ROOM_DEPOSIT_SUCCESS';
export const UPDATE_ROOM_DEPOSIT_FAILURE = 'UPDATE_ROOM_DEPOSIT_FAILURE';

// Action Creators for Room Deposit Waiting
export const fetchRoomDepositWaitingRequest = () => ({
    type: FETCH_ROOM_DEPOSIT_WAITING_REQUEST,
});

export const fetchRoomDepositWaitingSuccess = (deposit) => ({
    type: FETCH_ROOM_DEPOSIT_WAITING_SUCCESS,
    payload: deposit,
});

export const fetchRoomDepositWaitingFailure = (error) => ({
    type: FETCH_ROOM_DEPOSIT_WAITING_FAILURE,
    payload: error,
});

// Action Creators for Room Deposit Subtotal
export const fetchRoomDepositSubtotalRequest = () => ({
    type: FETCH_ROOM_DEPOSIT_SUBTOTAL_REQUEST,
});

export const fetchRoomDepositSubtotalSuccess = (deposit) => ({
    type: FETCH_ROOM_DEPOSIT_SUBTOTAL_SUCCESS,
    payload: deposit,
});

export const fetchRoomDepositSubtotalFailure = (error) => ({
    type: FETCH_ROOM_DEPOSIT_SUBTOTAL_FAILURE,
    payload: error,
});

// Action Creators for Update Room Deposit
export const updateRoomDepositRequest = () => ({
    type: UPDATE_ROOM_DEPOSIT_REQUEST,
});

export const updateRoomDepositSuccess = (deposit) => ({
    type: UPDATE_ROOM_DEPOSIT_SUCCESS,
    payload: deposit,
});

export const updateRoomDepositFailure = (error) => ({
    type: UPDATE_ROOM_DEPOSIT_FAILURE,
    payload: error,
});

// Thunk action to fetch room deposit waiting
let latestDepositSearch = 0;
export const fetchRoomDepositWaiting = () => {
    return async (dispatch) => {
        const requestId = ++latestDepositSearch;
        dispatch(fetchRoomDepositWaitingRequest());
        try {
            const deposit = await apiGetRoomDepositWaiting();
            if (requestId === latestDepositSearch) dispatch(fetchRoomDepositWaitingSuccess(deposit));
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch waiting deposit.';
            if (requestId === latestDepositSearch) dispatch(fetchRoomDepositWaitingFailure(errorMessage));
        }
    };
};

// Thunk action to fetch room deposit subtotal
export const fetchRoomDepositSubtotal = (depositData) => {
    return async (dispatch) => {
        const requestId = ++latestDepositSearch;
        dispatch(fetchRoomDepositSubtotalRequest());
        try {
            const subtotal = await apiGetRoomDepositSubtotal(depositData);
            if (requestId === latestDepositSearch) dispatch(fetchRoomDepositSubtotalSuccess(subtotal));
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch deposit subtotal.';
            if (requestId === latestDepositSearch) dispatch(fetchRoomDepositSubtotalFailure(errorMessage));
        }
    };
};

// Thunk action to update room deposit
export const updateRoomDeposit = (depositData) => {
    return async (dispatch) => {
        dispatch(updateRoomDepositRequest());
        try {
            const updatedDeposit = await apiUpdateRoomDeposit(depositData);
            dispatch(updateRoomDepositSuccess(updatedDeposit));
            return updatedDeposit;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to update room deposit.';
            dispatch(updateRoomDepositFailure(errorMessage));
            throw error;
        }
    };
};
